module.exports = __webpack_public_path__ + "img/5.1a57fc97.jpg";